import {useMemo, useState} from "react";
import {ObjectMeterCheckAssoc} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import {useDebouncedValue} from "@mantine/hooks";

export type UseMeterFlowVolumeDataTableFilterProps = Omit<UseDataTableFilterProps<ObjectMeterCheckAssoc>, 'filterConfig'>

export function useObjectMeterCheckAssocDataTableFilter(props: UseMeterFlowVolumeDataTableFilterProps): UseDataTableFilterResult<ObjectMeterCheckAssoc> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [objectQuery, setMeterQuery] = useState<string | undefined>(undefined);
  const [objectDebouncedQuery] = useDebouncedValue(objectQuery, 200);

  const filterConfig: DataTableFilterConfig<ObjectMeterCheckAssoc> = useMemo(() => {
    return {
      "object": {
        setQuery: setMeterQuery,
        query: objectQuery,
        debouncedQuery: objectDebouncedQuery,
        filter: (record, query) => !record.objectName || !record.objectName.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    objectQuery,
    objectDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
